import request from '@/utils/request'

const resetCurrentUserTraining = () => {
  return request({
    url: `${process.env.VUE_APP_SELECTGOODS_API}/training/reset`,
    method: 'post'
  })
} 

export default { 
  resetCurrentUserTraining 
}
